import { type Session } from '@halo/chat-sdk-react';
import { Text } from '@chakra-ui/react';
import { useIsMyMsg } from '@/scripts/hooks';
import { MsgMediaCard, MsgMediaCardContent } from '../msg-media-card';
import {
  MsgMediaHangUpContent,
  type MsgMediaHangUpContentProps,
} from './msg-media-hang-up-content';

export interface MsgMediaHangUpProps extends MsgMediaHangUpContentProps {
  session: Session;
}

export const MsgMediaHangUp = memo(function MsgMediaHangUp({
  message,
  session,
}: MsgMediaHangUpProps) {
  const { t } = useTranslation();
  const { create_uid } = message.payload;
  const newMessage = useMemo(() => {
    return {
      ...message,
      owner_id: create_uid,
      origin_owner_id: message.owner_id,
    };
  }, [create_uid, message]);

  const isMe = useIsMyMsg(newMessage);

  return (
    <MsgMediaCard message={newMessage} session={session}>
      <MsgMediaCardContent
        message={newMessage}
        title={isMe ? t('calls.callHangUpTitle') : t('calls.callHangUpTitleReceiver')}
        description={
          <MsgMediaHangUpContent message={newMessage}>
            {({ duration }) => <Text>{duration}</Text>}
          </MsgMediaHangUpContent>
        }
      ></MsgMediaCardContent>
    </MsgMediaCard>
  );
});
